import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsCategories(
  {
    page, size, direction, sort,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,

    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsCategory(goodsCategoryId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories/${goodsCategoryId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsCategory(
  {
    parentId,
    name,
    nameEn,
    coverPath,
    code,
    seriesId,
    isVip,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories`,
    method: 'post',
    data: {
      parentId,
      name,
      nameEn,
      code,
      coverPath,
      seriesId,
      isVip,
    },
  });
}

/**
 * 更新
 * @param goodsCategoryId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsCategory(goodsCategoryId, {
  parentId,
  name,
  nameEn,
  coverPath,
  code,
  seriesId,
  isVip,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories/${goodsCategoryId}`,
    method: 'patch',
    data: {
      parentId,
      name,
      nameEn,
      coverPath,
      code,
      seriesId,
      isVip,
    },
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsCategory(goodsCategoryId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories/${goodsCategoryId}`,
    method: 'delete',
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downGoodsCategory(goodsCategoryId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories/${goodsCategoryId}/down`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upGoodsCategory(goodsCategoryId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-categories/${goodsCategoryId}/up`,
    method: 'patch',
  });
}

export function _getCategoryByVipSeries(name) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/vip/category/${name}`,
    method: 'get',
  });
}

export function _getCategoryBySeries() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}//category/series`,
    method: 'get',
  });
}
export default {};
